<nx-pageTitle-box
  class="mb-3"
  [label]="'rentModule.generalSettingsComponent.pageTitle.label' | translate"
  [icon]="'icon-settings'"
  [iconToolTip]="'rentModule.generalSettingsComponent.pageTitle.iconTooltip' | translate"
  [bcRootLvlLabel]="'rentModule.generalSettingsComponent.breadcrumb.rootLabel' | translate"
  [bcRootLvlPath]="'settings'">
    <ng-template nxTemplate="end">

      <nx-default-button
        *ngIf="!isEditable()"
        class="default-button ml-1"
        (click)="editSettings()"
        [tooltip]="'rentModule.generalSettingsComponent.editButton.tooltip' | translate"
        icon="icon-edit">
      </nx-default-button>

      <nx-default-button
        *ngIf="isEditable()"
        class="default-button reject"
        (click)="abortEditSettings()"
        [label]="'rentModule.generalSettingsComponent.cancelButton.label' | translate">
      </nx-default-button>

      <nx-default-button
        *ngIf="isEditable()"
        [style]="'dark'"
        class="confirm  ml-1"
        (click)="updateSettings()"
        [label]="'rentModule.generalSettingsComponent.saveButton.label' | translate">
      </nx-default-button>

    </ng-template>
  </nx-pageTitle-box>
<app-settings-form
  [form]="form"
  [settings]="settings()"
  (fileChanged)="onFileChanged()">
</app-settings-form>

